import { render } from "./ListaNcms.vue?vue&type=template&id=47dfa6d0"
import script from "./ListaNcms.vue?vue&type=script&lang=js"
export * from "./ListaNcms.vue?vue&type=script&lang=js"

import "./ListaNcms.vue?vue&type=style&index=0&id=47dfa6d0&lang=css"

import exportComponent from "C:\\Users\\User\\Documents\\PROJETOS - LEFISC\\front_revisor\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__